



































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { SchoolGroup } from '@/models/school-group/school-group';
import { AddSchoolGroupRequest } from '@/models/school-group/add-school-group-request';
import { GEnum } from '@/constants/enum.defination';
import { SchoolGroupStudent } from '@/models/school-group/school-group-student';
import { GroupSetting } from '@/models/school-group/group-setting';
import { Group } from '@/models/school-group/group';
import { GroupModalProperty } from '@/models/school-group/group-modal-property';
import { SchoolGroupSearch } from '@/models/school-group/school-group-search';
import { SchoolGroupRespose } from '@/models/school-group/school-group-response';
import GClassManagementGroupingProposalConfirm from './GClassManagementGroupingProposalConfirm.vue';
import GClassManagementGroupProposal from '@/views/GClassManagement/GClassManagementGroupProposal.vue';
import GClassManagementGroupTable from './GClassManagementGroupTable.vue';
import GClassManagementGroupSettingModal from './GClassManagementGroupSettingModal.vue';
import { studentFilterModule } from '@/store/modules/frames/student-filters.module';
import { groupModule } from '@/store/modules/entities/group.module';
import { studentModule } from '@/store/modules/entities/student.module';
import { globalModule } from '@/store/modules/global.module';
@Component({
  name: 'GClassManagementGroupingProposal',
  components: {
    GClassManagementGroupProposal,
    GClassManagementGroupSettingModal,
    GClassManagementGroupTable,
    GClassManagementGroupingProposalConfirm,
  },
  computed: {},
  methods: {},
})
export default class GClassManagementGroupingProposal extends mixins(GPageBase) {
  isGroupingSetting: boolean = false;
  isBlankNonCategories: boolean = false;

  mounted() {}

  get canGroupEntry(): boolean {
    return groupModule.isFourStudentByGroup && this.isBlankNonCategories;
  }

  transferStudentInGroup(value: boolean): void {
    this.isBlankNonCategories = value;
  }

  get isOldSchoolYear(): boolean {
    return globalModule.isOldSchoolYear;
  }
  get canGrouping(): boolean {
    return this.targetStudentTotalRecords > 5;
  }

  get targetStudentTotalRecords(): number {
    return studentModule.students.totalRecords;
  }

  get isGroupSettingsDataSubmitted(): boolean {
    return groupModule.groupModalProperty.isGroupSettingsDataSubmitted;
  }

  get groupSettings(): GroupSetting {
    return groupModule.groupSetting;
  }

  get schoolGroups(): SchoolGroup[] {
    return groupModule.schoolGroups;
  }

  get studentGroups(): SchoolGroupStudent[] {
    return groupModule.studentGroups;
  }

  get targetType(): number {
    return studentFilterModule.targetType;
  }

  get targetID(): number {
    return studentFilterModule.targetID;
  }

  get selectedTagIDs(): number[] {
    return studentFilterModule.selectedTagIDs;
  }

  get selectedCommaTagIDs(): string {
    return studentFilterModule.commaSelectedTagIDs;
  }

  handleGroupingCancel(): void {
    const schoolGroupSettingInfoOptions = {
      isShowGroupsettingModal: false,
      isGroupSettingsDataSubmitted: false,
    };
    groupModule.setSchoolGroupSettingInfo(schoolGroupSettingInfoOptions);
  }
  handleGroupSettingModal(): void {
    const schoolGroupSettingInfoOptions = {
      isShowGroupsettingModal: true,
      isGroupSettingsDataSubmitted: false,
    } as GroupModalProperty;
    groupModule.setSchoolGroupSettingInfo(schoolGroupSettingInfoOptions);
  }

  handleGroupPropsalSubmit(): void {
    let schoolGroupRequestData: AddSchoolGroupRequest = {
      group: [],
      groupType: this.groupSettings.groupType,
      growingPurpose: this.groupSettings.purposeOfTraining,
      schoolCompetencyID: this.groupSettings.schoolCompetencyID,
      memo: this.groupSettings.notes,
      name: this.groupSettings.groupName,
      targetID: this.targetID === 0 ? -1 : this.targetID,
      targetType: this.targetType === 0 ? -1 : this.targetType,
      tagIDs: this.selectedTagIDs,
    };
    if (this.studentGroups.length > 0) {
      this.studentGroups.forEach((group: SchoolGroupStudent) => {
        let singleGroup: Group = {
          groupName: group.groupName,
          groupNumber: group.groupID,
          studentIDs: group.studentList.map((student: any) => student.studentID),
        };
        schoolGroupRequestData.group.push(singleGroup);
      });
    }

    groupModule.createSchoolGroup(schoolGroupRequestData).then((response: SchoolGroupRespose) => {
      this.showNotice(GEnum.MessageType.Success, this.$t('CREATE_GROUP').toString(), this.$t('COMPLETE_CREATE_GROUP', {value: response.name}).toString(), 5);
      const schoolGroupSettingInfoOptions = {
        isShowGroupsettingModal: false,
        isGroupSettingsDataSubmitted: false,
      };
      groupModule.setSchoolGroupSettingInfo(schoolGroupSettingInfoOptions);
      groupModule.fetchSchoolGroup({
        targetType: this.targetType === 0 ? -1 : this.targetType,
        targetID: this.targetID === 0 ? -1 : this.targetID,
        selectedCommaTagIDs: studentFilterModule.commaSelectedTagIDs,
      } as SchoolGroupSearch);
    });
  }
}
